import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import EditClassForm from '../../components/edit-class-form';
import PortalCommunication from '../../portal-comms';
import {
    getClassByClassroomId,
    downloadStudentSignInCardsRequest,
    renameClassroomGroup,
    hideEditClassGroup,
    showEditClassGroup,
    showRenameGroup,
    hideRenameGroup,
    openRenameGroupConfirmationBeforeSubmit,
    closeRenameGroupConfirmationBeforeSubmit,
    saveModifiedClass,
    closeRenameGroupConfirmation,
    printTeacherSignInCard,
    openUnAssignTeachersModal,
    closeTeachersOperationConfirmationModal,
    unassignTeachers,
    printClassroomTeacherSignInCard,
    handleOnCloseValidationModal,
    deleteGroup,
    openDeleteNonEmptyGroupConfirmation,
    closeDeleteNonEmptyGroupConfirmation,
    closeDeleteGroupConfirmation,
    openChangeCourse,
    openDeleteGroupConfirmationBeforeSubmit,
    closeDeleteGroupConfirmationBeforeSubmit,
    closeEditClass,
    openAddGroup,
    closeAddGroup,
    addGroup,
    closeEditGroup
} from './actions';
import { clearFilterValue,
    updateSearchTerm,
    getProductClassrooms,
    getStudentByClassroomIdRequest,
    showHideSignInCardModalRequest } from '../class-roll/actions';
import { getProductTeachers } from '../teacher-roll/actions';
import { getYearGroups } from '../school-roll/actions';
import {
    getEditClassGroupVisibility,
    getSelectedGroupIsDefault,
    getSelectedGroup,
    getIsLoadingEditClassDetail,
    getClassroomDetail,
    getIsDownloadingSignInCards,
    getDisableConfirmationButtons,
    getIsSavingClass
} from './selectors';
import { getProduct } from '../school-roll/selectors';
import editClassEnum from './constants';
import { displayNewCourses } from '../../helpers/utils';

class EditClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addGroupIsActive: true,
            className: props.classroomDetail.name,
            canSubmit: false,
            yearGroup: `${props.classroomDetail.yearGroupEnum}`,
            refreshListOnCancel: false
        };

        this.newGroupName = '';

        this.handleOnCloseEditClass = this.handleOnCloseEditClass.bind(this);
        this.handleOnCloseDeleteGroupModal = this.handleOnCloseDeleteGroupModal.bind(this);
        this.handleOnDownloadStudentSignInCards = this.handleOnDownloadStudentSignInCards.bind(this);
        this.handleOnClassNameChange = this.handleOnClassNameChange.bind(this);
        this.handleOnSaveClass = this.handleOnSaveClass.bind(this);
        this.handleOnYearGroupChange = this.handleOnYearGroupChange.bind(this);
        this.handleOnTeacherUnassign = this.handleOnTeacherUnassign.bind(this);
        this.handleOnUnassignConfirm = this.handleOnUnassignConfirm.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.handleOnPrintTeacherSignInCard = this.handleOnPrintTeacherSignInCard.bind(this);
        this.getClassYearGroups = this.getClassYearGroups.bind(this);
        this.handleOnDeleteGroupRequest = this.handleOnDeleteGroupRequest.bind(this);
        this.handleOnManageStudents = this.handleOnManageStudents.bind(this);
        this.handleOnManageStudentsBeforeDeleteGroup = this.handleOnManageStudentsBeforeDeleteGroup.bind(this);
        this.downloadingTeachersIds = new Set();
        this.displayNewCourses = displayNewCourses();
    }

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    componentDidMount() {
        const {
            selectedProduct,
            match,
            yearGroups
        } = this.props;
        this.props.getClassByClassroomId(selectedProduct.id, match.params.classroomId);

        if (yearGroups.length <= 1) {
            this.props.getYearGroups();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isUpdateSuccessful && nextProps.isSavingClass !== this.props.isSavingClass) {
            this.handleOnCloseEditClass();
        }

        if (nextProps.classroomDetail.name !== this.props.classroomDetail.name ||
            nextProps.classroomDetail.yearGroupShortName !== this.props.classroomDetail.yearGroupShortName) {
            this.setState({
                className: nextProps.classroomDetail.name.trim(),
                yearGroup: `${nextProps.classroomDetail.yearGroupEnum}`
            });
        }

        if (nextProps.refreshEditClass && nextProps.refreshEditClass !== this.props.refreshEditClass) {
            this.props.getClassByClassroomId(this.props.selectedProduct.id, this.props.match.params.classroomId);
        }

        if (nextProps.isDownloadingSignInCards !== this.props.isDownloadingSignInCards) {
            setTimeout(this.props.showHideSignInCardModalRequest(false), 1000);
        }
    }

    getClassYearGroups = () => {
        const result = [];
        this.props.yearGroups.map((val) => {
            if (Number(val.key) !== -1) {
                result.push(val);
            }
            return false;
        });
        return result;
    };

    validateClassModel = (className) => {
        if (className.trim() !== '') {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }
    };

    handleOnCloseEditClass = () => {
        this.props.updateSearchTerm('');
        this.props.clearFilterValue();
        this.context.router.history.push('/classes');
        if (this.state.refreshListOnCancel) {
            this.props.closeEditClass();
        }
    };

    handleOnDownloadStudentSignInCards = (format) => {
        const { selectedProduct, match } = this.props;
        this.props.downloadStudentSignInCardsRequest(selectedProduct.id, match.params.classroomId, format);
    };

    handleOnClassNameChange = (event) => {
        this.setState({ className: event.target.value });
        this.validateClassModel(event.target.value);
        return true;
    };

    handleOnCloseRenameGroupModal = () => {
        this.props.hideRenameGroup();
        this.props.closeEditGroup();
    };

    handleOnCancelRenameGroupModal = () => {
        this.props.hideRenameGroup();
    };

    handleOnShowRenameGroupModal = () => {
        this.props.showRenameGroup();
    };

    handleOnConfirmRenameGroup =(newGroupName) => {
        this.newGroupName = newGroupName;
        this.props.openRenameGroupConfirmationBeforeSubmit();
    };

    handleOnCancelRenameGroupConfirmationBeforeSubmit = () => {
        this.props.closeRenameGroupConfirmationBeforeSubmit();
    };

    handleOnCloseRenameGroupConfirmation = () => {
        this.props.closeRenameGroupConfirmation();
    };

    handleOnRenameClassroomGroup = () => {
        this.props.renameClassroomGroup(
            this.props.selectedGroup.classroomId,
            this.props.selectedGroup.id,
            this.newGroupName);
    };

    handleOnYearGroupChange = (name, value) => {
        this.setState({ yearGroup: value });
        this.validateClassModel(this.state.className);
    };

    handleOnSaveClass() {
        const { match } = this.props;
        this.props.saveModifiedClass(match.params.classroomId, this.state.className, this.state.yearGroup);
    }

    handleOnDownloadTeacherSignInCards = (teacherId) => {
        const { selectedProduct } = this.props;
        this.props.printTeacherSignInCard(selectedProduct.id, teacherId);
    };

    handleOnTeacherUnassign = (teacherId) => {
        this.setState({ showModal: true, teacherId });
        this.props.openUnAssignTeachersModal();
    };

    teachersOperationSuccessConfirmation = () => {
        this.setState({ refreshListOnCancel: true });
        const { selectedProduct, match } = this.props;
        this.handleOnCloseModal();
        this.props.getProductClassrooms(selectedProduct.id);
        this.props.getProductTeachers(selectedProduct.id);
        this.props.closeTeachersOperationConfirmationModal();
        this.props.getClassByClassroomId(selectedProduct.id, match.params.classroomId);
    };

    handleOnCloseModal = () => {
        this.setState({ showModal: false });
    };

    handleOnUnassignConfirm = () => {
        const { classroomDetail, selectedProduct } = this.props;
        const selectedTeachers = [];
        selectedTeachers.push(this.state.teacherId);
        this.props.unassignTeachers(classroomDetail.classroomId, selectedTeachers, selectedProduct.id);
    };

    handleOnPrintTeacherSignInCard = (teacherId) => {
        this.downloadingTeachersIds.add(teacherId);
        this.props.printClassroomTeacherSignInCard(teacherId, this.props.selectedProduct.id, this.downloadingTeachersIds, 'QR_3X3');
    };

    handleOnDeleteGroup = () => {
        this.props.deleteGroup(this.props.selectedGroup.classroomId, this.props.selectedGroup.id);
    };

    handleOnDeleteNonEmptyGroup = () => {
        this.props.closeDeleteNonEmptyGroupConfirmation();
    };

    handleOnAssignTeacher = () => {
        const assignType = 'teacherToClass';
        this.context.router.history.push(`/assign-user/${this.props.match.params.classroomId}/${assignType}`);
    }

    handleOnCancelDeleteGroupConfirmationBeforeSubmit = () => {
        this.props.closeDeleteGroupConfirmationBeforeSubmit();
    };

    handleOnCloseDeleteGroupConfirmation = () => {
        this.props.closeDeleteGroupConfirmation();
    };

    handleOnDeleteGroupRequest = () => {
        if (this.props.selectedGroup.studentIds.length > 0) {
            this.props.openDeleteNonEmptyGroupConfirmation();
        } else {
            this.props.openDeleteGroupConfirmationBeforeSubmit();
        }
    };

    handleOnCloseDeleteGroupModal = () => {
        this.props.closeDeleteGroupConfirmationBeforeSubmit();
        this.props.closeEditGroup();
    }

    handleOnManageStudents = (classId, classroomName, groupId) => {
        this.props.getStudentByClassroomIdRequest(classId);
        this.props.closeEditGroup();
        const moduleId = window.pppAppConfig ? window.pppAppConfig.ModuleIdStudentMgmt : editClassEnum.FALLBACK_ID;
        const sourceModuleId = window.pppAppConfig ? window.pppAppConfig.ModuleIdSchoolRoll : editClassEnum.FALLBACK_ID;
        PortalCommunication.requestModuleChange({ classId, moduleId, classroomName, groupId, sourceModuleId });
    }

    handleOnManageStudentsBeforeDeleteGroup = (classroomId, classroomName, groupId) => {
        this.handleOnDeleteNonEmptyGroup();
        this.handleOnManageStudents(classroomId, classroomName, groupId);
    }

    handleOnStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(true);
    }

    handleOnCancelStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(false);
    }

    render() {
        return (<EditClassForm
            canSubmit={this.state.canSubmit}
            className={this.state.className}
            downloadStudentSignInCards={this.handleOnDownloadStudentSignInCards}
            downloadTeacherSignInCards={this.handleOnDownloadTeacherSignInCards}
            handleDeleteNonEmptyGroup={this.handleDeleteNonEmptyGroup}
            handleOnAssignTeacher={this.handleOnAssignTeacher}
            handleOnCancelDeleteGroupConfirmationBeforeSubmit={this.handleOnCancelDeleteGroupConfirmationBeforeSubmit}
            handleOnCancelRenameGroupConfirmationBeforeSubmit={this.handleOnCancelRenameGroupConfirmationBeforeSubmit}
            handleOnCancelRenameGroupModal={this.handleOnCancelRenameGroupModal}
            handleOnClassNameChange={this.handleOnClassNameChange}
            handleOnCloseDeleteGroupConfirmation={this.handleOnCloseDeleteGroupConfirmation}
            handleOnCloseDeleteGroupModal={this.handleOnCloseDeleteGroupModal}
            handleOnCloseEditClass={this.handleOnCloseEditClass}
            handleOnCloseModal={this.handleOnCloseModal}
            handleOnCloseRenameGroupConfirmation={this.handleOnCloseRenameGroupConfirmation}
            handleOnCloseRenameGroupModal={this.handleOnCloseRenameGroupModal}
            handleOnDeleteGroup={this.handleOnDeleteGroup}
            handleOnDeleteGroupRequest={this.handleOnDeleteGroupRequest}
            handleOnDeleteNonEmptyGroup={this.handleOnDeleteNonEmptyGroup}
            handleOnManageStudents={this.handleOnManageStudents}
            handleOnManageStudentsBeforeDeleteGroup={this.handleOnManageStudentsBeforeDeleteGroup}
            handleOnOkRenameGroup={this.handleOnConfirmRenameGroup}
            handleOnPrintTeacherSignInCard={this.handleOnPrintTeacherSignInCard}
            handleOnRenameGroup={this.handleOnRenameClassroomGroup}
            handleOnSaveClass={this.handleOnSaveClass}
            handleOnShowRenameGroupModal={this.handleOnShowRenameGroupModal}
            handleOnTeacherUnassign={this.handleOnTeacherUnassign}
            handleOnUnassignConfirm={this.handleOnUnassignConfirm}
            handleOnYearGroupChange={this.handleOnYearGroupChange}
            isLoading={this.props.disableConfirmationButtons}
            showModal={this.state.showModal}
            teachersOperationSuccessConfirmation={this.teachersOperationSuccessConfirmation}
            yearGroup={this.state.yearGroup}
            {...this.props}
            displayNewCourses={this.displayNewCourses}
            handleOnCancelStudentSignInCards={this.handleOnCancelStudentSignInCards}
            handleOnStudentSignInCards={this.handleOnStudentSignInCards}
            yearGroups={this.getClassYearGroups()}
        />);
    }
}

EditClass.propTypes = {
    getClassByClassroomId: PropTypes.func,
    match: PropTypes.object.isRequired,
    selectedProduct: PropTypes.object,
    isLoadingEditClassDetail: PropTypes.bool,
    classroomDetail: PropTypes.object,
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    downloadStudentSignInCardsRequest: PropTypes.func,
    isDownloadingSignInCards: PropTypes.bool,
    selectedGroup: PropTypes.object,
    renameClassroomGroup: PropTypes.func,
    handleOnRenameGroup: PropTypes.func,
    handleOnCloseRenameGroupModal: PropTypes.func,
    handleOnCloseDeleteGroupModal: PropTypes.func,
    isRenameGroupInProgress: PropTypes.bool,
    handleOnShowRenameGroupModal: PropTypes.func,
    handleOnCloseValidationModal: PropTypes.func,
    showRenameGroup: PropTypes.func,
    hideRenameGroup: PropTypes.func,
    handleOnOkRenameGroup: PropTypes.func,
    openRenameGroupConfirmationBeforeSubmit: PropTypes.func,
    closeRenameGroupConfirmationBeforeSubmit: PropTypes.func,
    saveModifiedClass: PropTypes.func,
    getYearGroups: PropTypes.func,
    closeRenameGroupConfirmation: PropTypes.func,
    printTeacherSignInCard: PropTypes.func,
    openUnAssignTeachersModal: PropTypes.func,
    closeTeachersOperationConfirmationModal: PropTypes.func,
    unassignTeachers: PropTypes.func,
    isUserOperationModalOpen: PropTypes.bool,
    disableConfirmationButtons: PropTypes.bool,
    isSavingClass: PropTypes.bool,
    printClassroomTeacherSignInCard: PropTypes.func,
    downloadingTeachersIds: PropTypes.object,
    isUpdateSuccessful: PropTypes.bool,
    deleteGroup: PropTypes.func,
    hideEditClassGroup: PropTypes.func,
    refreshEditClass: PropTypes.bool,
    showDeleteNonEmptyGroupConfirmationModal: PropTypes.bool,
    showDeleteGroupConfirmation: PropTypes.bool,
    showDeleteGroupConfirmationBeforeSubmit: PropTypes.bool,
    openDeleteNonEmptyGroupConfirmation: PropTypes.func,
    closeDeleteNonEmptyGroupConfirmation: PropTypes.func,
    openDeleteGroupConfirmationBeforeSubmit: PropTypes.func,
    closeDeleteGroupConfirmation: PropTypes.func,
    closeDeleteGroupConfirmationBeforeSubmit: PropTypes.func,
    openChangeCourse: PropTypes.func,
    changeCourseIsActive: PropTypes.bool,
    closeEditClass: PropTypes.func,
    getStudentByClassroomIdRequest: PropTypes.func,
    clearFilterValue: PropTypes.func,
    updateSearchTerm: PropTypes.func,
    closeEditGroup: PropTypes.func,
    getProductTeachers: PropTypes.func,
    getProductClassrooms: PropTypes.func,
    showHideSignInCardModalRequest: PropTypes.func,
    showHideSignInCardModal: PropTypes.bool
};

const mapStateToProps = state => ({
    addGroupIsActive: state.editClass.addGroupIsActive,
    addGroupInProgress: state.editClass.addGroupInProgress,
    addGroupIsSuccess: state.editClass.addGroupIsSuccess,
    addGroupAddedGroup: state.editClass.addGroupAddedGroup,
    addGroupExceedGroupError: state.editClass.addGroupExceedGroupError,
    changeCourseIsActive: state.editClass.changeCourseIsActive,
    changeCourseClassroomId: state.editClass.changeCourseClassroomId,
    changeCourseGroupId: state.editClass.changeCourseGroupId,
    classroomDetail: getClassroomDetail(state),
    disableConfirmationButtons: getDisableConfirmationButtons(state),
    editClassGroupIsVisible: getEditClassGroupVisibility(state),
    isSelectedGroupDefault: getSelectedGroupIsDefault(state),
    isDownloadingSignInCards: getIsDownloadingSignInCards(state),
    isLoadingEditClassDetail: getIsLoadingEditClassDetail(state),
    isSavingClass: getIsSavingClass(state),
    selectedGroup: getSelectedGroup(state),
    selectedProduct: getProduct(state),
    showRenameGroupModal: state.editClass.showRenameGroupModal,
    showRenameGroupConfirmationModal: state.editClass.showRenameGroupConfirmationModal,
    isRenameGroupInProgress: state.editClass.isRenameGroupInProgress,
    showRenameGroupConfirmationBeforeSubmit: state.editClass.showRenameGroupConfirmationBeforeSubmit,
    isUserOperationModalOpen: state.editClass.isUserOperationModalOpen,
    downloadingTeachersIds: state.editClass.downloadingTeachersIds,
    isUpdateSuccessful: state.editClass.isUpdateSuccessful,
    editClassValidationMessage: state.editClass.editClassValidationMessage,
    yearGroups: state.studentRoll.dataFilterOption.yearGroups,
    isDeletingGroupInProgress: state.editClass.isDeletingGroupInProgress,
    showDeleteNonEmptyGroupConfirmationModal: state.editClass.showDeleteNonEmptyGroupConfirmationModal,
    showDeleteGroupConfirmation: state.editClass.showDeleteGroupConfirmation,
    showDeleteGroupConfirmationBeforeSubmit: state.editClass.showDeleteGroupConfirmationBeforeSubmit,
    refreshEditClass: state.editClass.refreshEditClass,
    showHideSignInCardModal: state.classRoll.showHideSignInCardModal
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        downloadStudentSignInCardsRequest,
        getClassByClassroomId,
        hideEditClassGroup,
        showRenameGroup,
        hideRenameGroup,
        openRenameGroupConfirmationBeforeSubmit,
        closeRenameGroupConfirmationBeforeSubmit,
        renameClassroomGroup,
        showEditClassGroup,
        saveModifiedClass,
        getYearGroups,
        closeRenameGroupConfirmation,
        printTeacherSignInCard,
        openUnAssignTeachersModal,
        closeTeachersOperationConfirmationModal,
        handleOnCloseValidationModal,
        unassignTeachers,
        openChangeCourse,
        printClassroomTeacherSignInCard,
        deleteGroup,
        openDeleteNonEmptyGroupConfirmation,
        closeDeleteNonEmptyGroupConfirmation,
        openDeleteGroupConfirmationBeforeSubmit,
        closeDeleteGroupConfirmation,
        closeDeleteGroupConfirmationBeforeSubmit,
        closeEditClass,
        openAddGroup,
        closeAddGroup,
        addGroup,
        getStudentByClassroomIdRequest,
        closeEditGroup,
        clearFilterValue,
        updateSearchTerm,
        getProductClassrooms,
        getProductTeachers,
        showHideSignInCardModalRequest
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditClass);



// WEBPACK FOOTER //
// ./app/containers/edit-class/index.js